'use strict'

class exports.BaseHandler extends Handler

    resetFilters: () ->
        # Resets visibility on all filters

        for fg in @parent.filters.filter_groups()
            for f in fg.filters()
                f.enableFilter()

    hideAllFilterGroups: () ->
        for group in @parent.filters.filter_groups()
            @parent.filters.hideGroup group.name

    disableAllFilterGroups: () ->
        for group in @parent.filters.filter_groups()
            @parent.filters.disableGroup group.name


    importDefaultFilters: () ->
        locale = window.Config.get('app.locale')
        stateDisplay = if locale is 'en_CA' then 'Province' else 'State'
        zipDisplay = if locale is 'en_CA' then 'Postal Code' else 'ZIP Code'
        @parent.filters.importGroup
            name: 'Region Filters'
            filters: [
                {
                    name: 'years'
                    display_name: 'Year'
                },
                {
                    name: 'states'
                    display_name: stateDisplay
                },
                {
                    name: 'zones'
                    display_name: 'Zone'
                },
                {
                    name: 'zips'
                    display_name: zipDisplay
                }
            ]

        @parent.filters.importGroup
            name: 'Operation Filters'
            filters: [
                {
                    name: 'companies'
                    display_name: 'Company'
                },
                {
                    name: 'owners'
                    display_name: 'User'
                },
                {
                    name: 'farms'
                    display_name: 'Farm'
                    class: 'dropup'
                },
                {
                    name: 'fields'
                    display_name: 'Field'
                    class: 'dropup'
                }
            ]


    finishRunning: () ->
        @filters = ko.toJSON @parent.filters.jsonize()
        if @currentOutput?
            promise = @currentOutput.buildTable()

        if promise? and promise.then?
            promise.then () =>
                if $.contains(document, @parent.msg[0]) and @parent.msg.length isnt 0
                    @parent.msg.message_writer 'success', 'Report Finished'
                    @parent.msg.message_writer 'hide'
        else
            if $.contains(document, @parent.msg[0]) and @parent.msg.length isnt 0
                @parent.msg.message_writer 'success', 'Report Finished'
                @parent.msg.message_writer 'hide'

    refreshReport: () ->
        refreshLayout = true
        if @beforeApply?
            refreshLayout = @beforeApply()
        if $.contains(document, @parent.msg[0]) and @parent.msg.length isnt 0
            @parent.msg.message_writer 'info', 'Running Report...'

        @filters = ko.toJSON @parent.filters.jsonize()

        if refreshLayout
            @loadLayout
                postOptions:
                    query: @filters
        else
            @afterLoadLayout()


    afterLoadLayout: () ->
        @parent.resize()

        master_sidebar = App.sidebar.element.find('.master_sidebar')
        sidebar_content = App.sidebar.element.find('.sidebar_content')

        # if we scrollin
        if sidebar_content[0].scrollHeight > sidebar_content.height()
            # Time to squeeze everything together, best we can
            master_sidebar.css { 'width': '296px', 'padding-left': '4px' }
            sidebar_content.css { 'overflow-y': 'auto' }

            # This problem comes from that Firefox and Chrome both apply scrollbars seemingly differently.
            # Chrome this should/will be ~15px, Firefox this will be 0px
            browser_added_width = master_sidebar.width() - sidebar_content.width()

            # If the scrollbar width is not added by the broswer it should be just 0px and thus we must pad ourselves
            # 17px is the 'standard' size I think for scrollbars, but I'm not sure if this number directly translates
            if browser_added_width is 0
                sidebar_content.css { 'overflow-y': 'auto', 'padding-right': '17px' }

        @finishRunning()


    setDefaultsAndRun: (years_to_add = 0, months_to_add = 0, days_to_add = 0, default_filters = {}, dateRangePickerDirection = 'up', doCrapWithYearsFilter = true) ->
        # if there are any date picker filters we added...
        App.sidebar.element.find('.dpl').datepicker()
        App.sidebar.element.find('.drp').daterangepicker({ autoApply: true, drops: dateRangePickerDirection, parentEl: '#bs2-container' })

        #set default year filter
        year = @parent.filters.findInGroup 'years'

        if year and doCrapWithYearsFilter and year.auto_select_by_default_flag is false
            if year.selected_values().length is 0
                cyear = new Date()

                cyear.setFullYear cyear.getFullYear() + years_to_add
                cyear.setMonth cyear.getMonth() + months_to_add
                cyear.setDate cyear.getDate() + days_to_add

                year.populateValues [
                    key: cyear.getFullYear()
                    value: cyear.getFullYear()
                ]
                year.applyFilter
                    key: cyear.getFullYear()
                    value: cyear.getFullYear()
                , false

            # Check if there are any filters that are restricted to year
            filtersListening = []
            for group in @parent.filters.filter_groups()
                for filter, index in group.filters()
                    if filter.listenForYear?
                        filtersListening.push filter
                        filter.listenForYear year.selected_values()
            year.selected_values.subscribe (newValue) ->
                for filter in filtersListening
                    filter.listenForYear newValue



        #set given default filters
        # for key, df of default_filters
        #     filter = @parent.filters.findInGroup key

        #     filter.populateValues [{ key: df.key, value: df.value }]
        #     filter.applyFilter {key: df.key, value: df.value}, false

        for fname, options of default_filters
            filter = @parent.filters.findInGroup fname
            for key, opt of options
                filter.populateValues [
                    key: opt.key
                    value: opt.value
                ]
                filter.applyFilter
                    key: opt.key
                    value: opt.value
                , false

        @parent.filters.fetchFilters @filterUrl, () =>
            @refreshReport()


    afterResize: () ->
        if @currentOutput?
            @currentOutput.resizeTable()


    print: () ->
        url = @printUrl + '?' + $.param { query: @filters }
        win = window.open(url, '_blank')

        win.onload = () ->
            win.print()


    destroy: () ->
        super()
        App.sidebar.element.find('.master_sidebar').css 'width', ''
        App.sidebar.element.find('.sidebar_content').css { 'overflow-y': '', 'padding-right': '' }
        $(@layoutSelector).empty()

        # clear selected & applied filters
        @parent.filters.clearAllFilters()
        @parent.appliedFilters = null

    ###
    Gets the first date of the year
    ###
    getFirstDateOfYear: () ->
        date = new Date()
        year = date.getFullYear()
        string = '01/01/' + year
        return string

    ###
    Turns a date into a string that fits into a datepicker input type (in bootstrap)
    ###
    getDateString: (date) =>
        day = @zeroPad date.getDate(), 2
        month = @zeroPad date.getMonth() + 1, 2
        year = date.getFullYear()
        string = month + '/' + day + '/' + year
        #console.log('The date produced is: ' + string)
        return string

    ###
    Does some fancy zero padding to help the getDateString function work the way we want it to.
    Posted by a stackoverflow user:
        http://stackoverflow.com/questions/2998784/how-to-output-integers-with-leading-zeros-in-javascript
    ###
    zeroPad: (num, places) ->
        zero = places - num.toString().length + 1
        return Array(+(zero > 0 and zero)).join('0') + num
